"use client";

import { buttonVariants } from "@watt/ui/components/ui/button";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { LogLevel, useLogger } from "next-axiom";

export default function ErrorPage({
  error
}: {
  error: Error & { digest?: string };
}) {
  const pathname = usePathname();
  const log = useLogger({ source: "error.tsx" });
  const status = error.message === "Invalid URL" ? 404 : 500;

  log.logHttpRequest(
    LogLevel.error,
    error.message,
    {
      host: window.location.href,
      path: pathname,
      statusCode: status
    },
    {
      cause: error.cause,
      digest: error.digest,
      error: error.name,
      stack: error.stack
    }
  );

  return (
    <div className="m-16 flex h-full flex-col items-center justify-center space-y-6 text-center">
      <h1 className="font-semibold text-5xl">Error</h1>
      <Image
        alt="Bill error"
        height={284}
        src={"/img/unhappy-bill.png"}
        width={200}
      />

      <p>
        Oh no something has gone wrong. Please refresh the page to try again or
        ...
      </p>
      <Link className={buttonVariants()} href="/">
        Return Home
      </Link>
    </div>
  );
}
